import {
    initializeApp,
    initializeBreadcrumbs,
    initializeEstablishment,
    initializeMember,
    initializeOrganization,
} from './app/app.initializers';
import { AppComponent } from './app/app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    heroArrowDownMini,
    heroArrowRightMini,
    heroCheckCircleMini,
    heroChevronDownMini,
    heroChevronLeftMini,
    heroChevronRightMini,
    heroPencilSquareMini,
    heroPlusMini,
    heroXMarkMini,
} from '@ng-icons/heroicons/mini';
import {
    heroArrowDown,
    heroArrowDownCircle,
    heroArrowPath,
    heroArrowRight,
    heroArrowRightOnRectangle,
    heroArrowTopRightOnSquare,
    heroArrowUpTray,
    heroBars3,
    heroBriefcase,
    heroBuildingOffice2,
    heroCalendar,
    heroChevronDown,
    heroClock,
    heroCog6Tooth,
    heroCreditCard,
    heroDocument,
    heroEllipsisVertical,
    heroExclamationTriangle,
    heroEye,
    heroHandRaised,
    heroHome,
    heroIdentification,
    heroPencil,
    heroPencilSquare,
    heroPlus,
    heroRectangleGroup,
    heroShieldCheck,
    heroStar,
    heroTrash,
    heroUser,
    heroUserGroup,
    heroUsers,
    heroXCircle,
} from '@ng-icons/heroicons/outline';
import { NgIconsModule } from '@ng-icons/core';
import { routes } from './app/app.routes';
import {
    PreloadAllModules,
    provideRouter,
    withComponentInputBinding,
    withPreloading,
    withRouterConfig,
} from '@angular/router';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { ResponseInterceptorService } from './app/core/services/response-interceptor.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom, LOCALE_ID, provideAppInitializer } from '@angular/core';
import { CacheService } from '@knalgeel/pandora';
import { SubdomainResolver } from './app/core/resolvers/subdomain.resolver';
import { provideImgixLoader, registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { providePrimeNG } from 'primeng/config';
import { AresTheme } from './app/theme/ares-theme';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MessageService } from 'primeng/api';
import { environment } from './environments/environment';
import { provideGraphQL } from './graphql/graphql.provider';
import { provideLucideConfig } from '@lucide/angular';

registerLocaleData(localeNl);

bootstrapApplication(AppComponent, {
        providers: [
            importProvidersFrom(
                BrowserModule,
                NgIconsModule.withIcons({
                    heroUsers,
                    heroXCircle,
                    heroArrowDown,
                    heroArrowDownMini,
                    heroArrowRight,
                    heroArrowRightMini,
                    heroDocument,
                    heroBars3,
                    heroPlus,
                    heroChevronDownMini,
                    heroPlusMini,
                    heroPencilSquare,
                    heroTrash,
                    heroArrowRightOnRectangle,
                    heroUser,
                    heroBuildingOffice2,
                    heroCog6Tooth,
                    heroPencil,
                    heroArrowDownCircle,
                    heroArrowPath,
                    heroChevronRightMini,
                    heroPencilSquareMini,
                    heroChevronLeftMini,
                    heroCheckCircleMini,
                    heroStar,
                    heroHome,
                    heroClock,
                    heroArrowTopRightOnSquare,
                    heroHandRaised,
                    heroExclamationTriangle,
                    heroEllipsisVertical,
                    heroChevronDown,
                    heroBriefcase,
                    heroCalendar,
                    heroIdentification,
                    heroUserGroup,
                    heroCreditCard,
                    heroArrowUpTray,
                    heroRectangleGroup,
                    heroXMarkMini,
                    heroEye,
                    heroShieldCheck,
                }),
                ReactiveFormsModule,
                FormsModule,
            ),
            provideImgixLoader(environment.imgix.baseUrl),
            SubdomainResolver,
            CacheService,
            {
                provide: LOCALE_ID,
                useValue: 'nl-NL',
            },
            provideAppInitializer(() => {
                const initializerFn = (initializeOrganization)();
                return initializerFn();
            }),
            provideAppInitializer(() => {
                const initializerFn = (initializeEstablishment)();
                return initializerFn();
            }),
            provideAppInitializer(() => {
                const initializerFn = (initializeBreadcrumbs)();
                return initializerFn();
            }),
            provideAppInitializer(() => {
                const initializerFn = (initializeApp)();
                return initializerFn();
            }),
            provideAppInitializer(() => {
                const initializerFn = (initializeMember)();
                return initializerFn();
            }),
            {
                provide: HTTP_INTERCEPTORS,
                useClass: ResponseInterceptorService,
                multi: true,
            },
            {
                provide: MessageService,
                useClass: MessageService,
            },
            provideAnimationsAsync(),
            provideHttpClient(
                withInterceptorsFromDi()
            ),
            provideRouter(routes,
                withRouterConfig({
                    paramsInheritanceStrategy: 'always',
                }),
                withComponentInputBinding(),
                withPreloading(PreloadAllModules),
            ),
            provideGraphQL(),
            provideLucideConfig({
                strokeWidth: 1.7,
            }),
            providePrimeNG({
                theme: {
                    preset: AresTheme,
                    options: {
                        darkModeSelector: 'p-dark',
                        cssLayer: false,
                    },
                },
                inputStyle: 'outlined',
            }),
        ],
    },
).catch(err => console.error(err));
